import {
  ShieldCheck,
  Megaphone,
  TrendingUp,
  Mail,
  UserCheck,
  Share2,
  Database,
  Filter,
  CheckCircle2,
  Layers,
  FileSpreadsheet,
  Cpu,
} from "lucide-react";

export const VERIFICATION_HERO_STEPS = [
  {
    step: "01",
    title: "Verify",
    desc: "Multi-level human & algorithmic review of all contact points.",
    icon: ShieldCheck,
  },
  {
    step: "02",
    title: "Promote",
    desc: "Deploy campaigns directly to target audiences who intend to buy.",
    icon: Megaphone,
  },
  {
    step: "03",
    title: "Convert",
    desc: "Expand your sales pipeline with easy-to-convert, verified leads.",
    icon: TrendingUp,
  },
];

export const RADIAL_PROCEDURES = [
  {
    id: 1,
    step: "01",
    label: "Accumulation",
    title: "Accumulation of Customer Data",
    desc: "Intake of your raw customer data and identification of lead parameters.",
    color: "#84cc16",
    icon: Database,
  },
  {
    id: 2,
    step: "02",
    label: "Classification",
    title: "Classification of Collected Data",
    desc: "The size of the database is inspected and segmented into relevant operational fields.",
    color: "#1e3a8a",
    icon: Layers,
  },
  {
    id: 3,
    step: "03",
    label: "Authentication",
    title: "Authentication of Customer Data",
    desc: "Manual review alongside intelligence sources to verify accuracy of phone, email, and social handles.",
    color: "#eab308",
    icon: ShieldCheck,
  },
  {
    id: 4,
    step: "04",
    label: "De-Duplication",
    title: "De-Duplication for Better Results",
    desc: "Inaccuracies and duplicate fields are eliminated to maintain maximum data integrity.",
    color: "#60a5fa",
    icon: Filter,
  },
  {
    id: 5,
    step: "05",
    label: "Scrubbing",
    title: "Scrubbing & Appending New Data",
    desc: "Rigorous verification tests to eliminate ineffective records and patch missing points.",
    color: "#10b981",
    icon: Cpu,
  },
  {
    id: 6,
    step: "06",
    label: "Delivery",
    title: "Delivery in Required Format",
    desc: "Final validated, authentic database exported cleanly to Excel format ready for immediate CRM deployment.",
    color: "#475569",
    icon: FileSpreadsheet,
  },
];

export const PROCEDURE_POINTS = [
  {
    title: "Enter and Verify the Database",
    desc: "The size of the database is inspected and then the verification process is determined. This also helps segment the data into relevant fields.",
    icon: Database,
  },
  {
    title: "Analyse and De-duplicate data",
    desc: "Data is analysed for inaccuracies and duplicate fields to be updated with relevant contact information by our in-house team of data scientists and research experts.",
    icon: Filter,
  },
  {
    title: "Authenticate & Update",
    desc: "We process the data under rigorous verification tests to maintain its authenticity and credibility. Once the data is finally updated and verified manually, we export them to the Excel Format.",
    icon: CheckCircle2,
  },
];

export const VERIFICATION_SERVICES = [
  {
    title: "Email Verification",
    desc: "We review your customer data and remove inactive and false email addresses that may affect your email deliverability statistics.",
    icon: Mail,
    stat: "99% Inbox Assurance",
  },
  {
    title: "Full Contact Verification",
    desc: "This service includes verification of contact name, email address, industry code, extension numbers, and other relevant information.",
    icon: UserCheck,
    stat: "360° Identity Audit",
  },
  {
    title: "Social Profile Verification",
    desc: "It includes reviewing your ideal customers' social profiles and insights to help you connect with them on multiple platforms.",
    icon: Share2,
    stat: "Multi-Channel Touch",
  },
];